import React from 'react';
import { Box, InputField, Checkbox } from 'vindi-ds-components';

const MinimumPrice = () => (
  <Box display='flex' justifyContent='space-between'>
    <MinimumPriceFields inputName='pricing_schema_attributes.minimum_price' inputLabel='Preço mínimo' checkboxLabel='Não definir preço do produto' />
    <MinimumPriceFields inputName='pricing_schema_attributes.price' inputLabel='Custo fixo' checkboxLabel='Não incluir custo fixo' />
  </Box>
);

const MinimumPriceFields = ({ inputName, inputLabel, checkboxLabel }) => (
  <Box display='flex' flexDirection='column' width='100%' mr='0.5em'>
    <InputField name={inputName} type='number' label={inputLabel} />
    <Checkbox label={checkboxLabel} id={checkboxLabel} />
  </Box>
);

export default MinimumPrice;
